import React from 'react';
import { Link } from 'react-router-dom';

const HeroSection = () => {
  return (
    <section className="relative h-screen flex items-center justify-center overflow-hidden">
      <div className="absolute inset-0 z-0">
        <img
          alt="Wildlife migration"
          className="w-full h-full object-cover"
          src="https://images.unsplash.com/photo-1564760055775-d63b17a55c44?w=1920&h=1080&fit=crop"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-surface via-surface/40 to-transparent"></div>
        <div className="absolute inset-0" style={{ background: 'radial-gradient(circle, transparent 20%, rgba(6, 14, 32, 0.8) 100%)' }}></div>
      </div>
      <div className="relative z-10 text-center px-6 max-w-5xl">
        <span className="font-label text-primary tracking-[0.3em] uppercase text-xs mb-6 block">
          Documenting the Great Wanderings
        </span>
        <h1 className="font-headline text-5xl md:text-8xl text-on-surface leading-tight mb-8">
          The <span className="italic font-normal">Epic Journeys</span> <br />of Earth
        </h1>
        <p className="font-body text-on-surface-variant text-lg md:text-xl max-w-2xl mx-auto mb-10 leading-relaxed">
          A digital archive dedicated to the preservation of migratory wisdom. Witness the rhythmic displacement of life across our blue planet.
        </p>
        <div className="flex flex-col sm:flex-row gap-6 justify-center">
          <Link
            to="/explorer"
            className="bg-gradient-to-r from-primary to-primary-container text-on-primary px-8 py-4 rounded-md font-label font-medium tracking-wide flex items-center gap-2 hover:brightness-110 transition-all justify-center"
          >
            Begin Exploration <span className="material-symbols-outlined text-sm">north_east</span>
          </Link>
          <Link
            to="/explorer"
            className="border border-outline-variant/30 backdrop-blur-md px-8 py-4 rounded-md font-label font-medium tracking-wide flex items-center gap-2 hover:bg-white/5 transition-all text-on-surface justify-center"
          >
            Open Field Journal
          </Link>
        </div>
      </div>
    </section>
  );
};

export default HeroSection;
